export default __webpack_public_path__ + "static/media/send.cce7f972.png";